<div class="content-grid">
  <div class="m-content">
    <mat-card class="mat-container">
      <mat-card-content>
        <div class="env-dialog-title">
          <h2>Create Environment</h2>
        </div> 
        <!-- <div class="close-button" (click)="closeModal()"> -->
          <!-- <button mat-button class="close-button" (click)="closeModal()"> -->
            <mat-icon class="close-button" (click)="closeModal()">cancel</mat-icon>
          <!-- </button> -->
        <!-- </div> -->
        <form [formGroup]="envForm" (ngSubmit)="onFormSubmit()">
          <div class="view-options">
            <mat-form-field appearance="outline" class="view-option-input">
              <mat-label>Environment Name</mat-label>
              <input type="text" matInput placeholder="Environment Name" formControlName="environment_name" required>
              <!-- Add a validation message for the required field -->
              <mat-error *ngIf="envForm.controls['environment_name'].hasError('required')">
                Environment Name is required
              </mat-error>
            </mat-form-field>
          </div>
          <mat-dialog-actions class="action-btn-section">
            <!-- <button mat-stroked-button (click)="closeModal()" class="previous">Cancel</button> -->
            <button mat-raised-button class="add-env-button" type="submit" [disabled]="!envForm.valid">Add</button>
          </mat-dialog-actions> 
        </form>  
      </mat-card-content>
    </mat-card>
  </div>
</div>